
  const topics = [
    "/ordini/aggiorna_app_qorder",
    "/ordini/aggiorna_qr_car_tmp_online",
    "/ordini/aggiorna_qr_tavolo",
    
  ];
  module.exports = topics; 